import { render, staticRenderFns } from "./adcarousel.vue?vue&type=template&id=f53cc21e&scoped=true"
import script from "./adcarousel.vue?vue&type=script&lang=js"
export * from "./adcarousel.vue?vue&type=script&lang=js"
import style0 from "./adcarousel.vue?vue&type=style&index=0&id=f53cc21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53cc21e",
  null
  
)

export default component.exports